import { Flex, Grid, Typography } from 'antd';
import { ReactComponent as BigLogo } from 'assets/logo/logo-big.svg';
import { clsx } from 'clsx';
import React from 'react';
const { Title } = Typography;
const { useBreakpoint } = Grid;

export interface PageHeaderProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  right?: React.ReactNode;
  bottom?: React.ReactNode;
  align?: React.CSSProperties['alignItems'];
  hideLogo?: boolean;
  compact?: boolean;
}

const PageHeader = (props: PageHeaderProps) => {
  const { title, children, right, bottom, align, hideLogo, compact } = props;
  const { xl, lg } = useBreakpoint();

  return (
    <>
      <Flex gap="large" align={align || 'start'}>
        {xl && !hideLogo && (
          <BigLogo className="print:hidden" style={{ minWidth: '285px' }} />
        )}

        <Flex vertical gap={compact ? 8 : 'large'} className="grow">
          <Flex vertical gap={compact ? 8 : 'large'} align="flex-start">
            <Flex gap="large" justify="space-between" className="w-full">
              <Title
                level={1}
                className={clsx('!m-0', {
                  '!leading-none !text-2xl': hideLogo,
                  '!text-xl !leading-7': compact,
                })}
              >
                {title}
              </Title>
              {lg && right}
            </Flex>

            {children}
          </Flex>
          {bottom}
        </Flex>
      </Flex>
      {!lg && right}
    </>
  );
};

export default PageHeader;
